module.exports = __webpack_public_path__ + "img/new-poll.dd1cdeef.png";